import img1 from '../images/icon/icon-friendly-1.svg';
import img2 from '../images/icon/icon-friendly-2.svg';
import img3 from '../images/icon/icon-friendly-3.svg';

import img4 from '../images/icon/friendly-01.svg';
import img5 from '../images/icon/friendly-02.svg';
import img6 from '../images/icon/friendly-03.svg';
import img7 from '../images/icon/friendly-04.svg';

const dataFriendly = [
    {
        id: 1,
        img: img1,
        title:'Video Freelancing Marketplace',
        classAction: 'text-color-1'
    },
    {
        id: 2,
        img: img2,
        title:'Pre-made Video Shot Marketplace',
        classAction: 'text-color-1'
    },
    {
        id: 3,
        img: img3,
        title:'Token-Based Payements',
        classAction: 'text-color-1'
    },
    {
        id: 4,
        img: img5,
        title:'Video Freelancing Marketplace',
    },
    {
        id: 5,
        img: img6,
        title:'Pre-made Video Shot Marketplace',
    },
    {
        id: 6,
        img: img7,
        title:'Token-Based Payements',
    },
    {
        id: 7,
        img: img4,
        title:'Interactive Collaboration Tools',
    },

]

export default dataFriendly;